import { GifOverlayProps } from '@giphy/react-components'
import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { VideoContext } from 'shared/components/context/video-manager'
import GAVideo from '../video-player/sdk-video-with-ga'
import Volume from './volume'
import useLocalStorage from 'react-use/lib/useLocalStorage'

const VideoContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
`

const VideoStyled = styled(GAVideo)<{ isReady: boolean }>`
    height: 100%;
    object-fit: contain;
    background: ${props => (props.isReady ? 'black' : 'transparent')};
`

const VideoOverlay = ({
    gif,
    width = 248,
    height,
    isHovered,
    volumeSize,
    gridPosition,
}: GifOverlayProps & { gridPosition?: number; width?: number; height?: number; volumeSize?: number }) => {
    const [mutedByBrowser, setMutedByBrowser] = useState(true)
    const [isReady, setIsReady] = useState(false)
    const { onStartHover, onFinishHover, setMuted, muted } = useContext(VideoContext)
    const [copied, setCopied] = useState<boolean>()
    const [hasCopiedLink, setHasCopiedLink] = useLocalStorage(`${gif.id}`, false)

    const toggleMute = () => {
        if (mutedByBrowser) {
            setMutedByBrowser(false)
            setMuted(false, true)
        } else {
            setMuted(!muted)
        }
    }

    const copyLink = () => {
        if (!copied && !hasCopiedLink) {
            setCopied(true)
            setHasCopiedLink(true)
        }
    }

    useEffect(() => {
        if (isHovered) {
            onStartHover?.(gif.id.toString())
        } else {
            setIsReady(false)
            onFinishHover?.(gif.id.toString())
            setCopied(false)
        }
    }, [isHovered])

    if (!isHovered) {
        return <Volume muted isHovered={false} volumeSize={volumeSize} gif={gif} />
    }

    return (
        <VideoContainer>
            <VideoStyled
                gif={gif}
                height={height}
                key={gif.id}
                loop
                muted={muted}
                width={width}
                isReady={isReady}
                onTimeUpdate={time => {
                    if (time > 0) {
                        setIsReady(true)
                    }
                }}
                onMuted={(muted: boolean) => setMutedByBrowser(muted)}
                gridPosition={gridPosition}
                copied={copied}
            />
            <Volume
                toggleMute={toggleMute}
                muted={muted || mutedByBrowser}
                isHovered={true}
                volumeSize={volumeSize}
                gif={gif}
                copyLink={copyLink}
            />
        </VideoContainer>
    )
}
export default VideoOverlay
